export default {
    aa: 'Afar',
    ab: 'Abjasio (o abjasiano)',
    ae: 'Avéstico',
    af: 'Afrikáans',
    ak: 'Akano',
    am: 'Amhárico',
    an: 'Aragonés',
    ar: 'Àrabe',
    as: 'Asamés',
    av: 'Avar (o ávaro)',
    ay: 'Aimara',
    az: 'Azerí',
    ba: 'Baskir',
    be: 'Bielorruso',
    bg: 'Búlgaro',
    bh: 'Bhoyapurí',
    bi: 'Bislama',
    bm: 'Bambara',
    bn: 'Bengalí',
    bo: 'Tibetano',
    br: 'Bretón',
    bs: 'Bosnio',
    ca: 'Catalán',
    ce: 'Checheno',
    ch: 'Chamorro',
    co: 'Corso',
    cr: 'Cree',
    cs: 'Checo',
    cu: 'Eslavo eclesiástico antiguo',
    cv: 'Chuvasio',
    cy: 'Galés',
    da: 'Danés',
    de: 'Alemán',
    dv: 'Maldivo (o dhivehi)',
    dz: 'Dzongkha',
    ee: 'Ewé',
    el: 'Griego (moderno)',
    en: 'Inglés',
    eo: 'Esperanto',
    es: 'Español (o castellano)',
    et: 'Estonio',
    eu: 'Euskera',
    fa: 'Persa',
    ff: 'Fula',
    fi: 'Finés (o finlandés)',
    fj: 'Fiyiano (o fiyi)',
    fo: 'Feroés',
    fr: 'Francés',
    fy: 'Frisón (o frisio)',
    ga: 'Irlandés (o gaélico)',
    gd: 'Gaélico escocés',
    gl: 'Gallego',
    gn: 'Guaraní',
    gu: 'Guyaratí (o gujaratí)',
    gv: 'Manés (gaélico manés o de Isla de Man)',
    ha: 'Hausa',
    he: 'Hebreo',
    hi: 'Hindi (o hindú)',
    ho: 'Hiri motu',
    hr: 'Croata',
    ht: 'Haitiano',
    hu: 'Húngaro',
    hy: 'Armenio',
    hz: 'Herero',
    ia: 'Interlingua',
    id: 'Indonesio',
    ie: 'Occidental',
    ig: 'Igbo',
    ii: 'Yi de Sichuán',
    ik: 'Iñupiaq',
    io: 'Ido',
    is: 'Islandés',
    it: 'Italiano',
    iu: 'Inuktitut (o inuit)',
    ja: 'Japonés',
    jv: 'Javanés',
    ka: 'Georgiano',
    kg: 'Kongo (o kikongo)',
    ki: 'Kikuyu',
    kj: 'Kuanyama',
    kk: 'Kazajo (o kazajio)',
    kl: 'Groenlandés (o kalaallisut)',
    km: 'Camboyano (o jemer)',
    kn: 'Canarés',
    ko: 'Coreano',
    kr: 'Kanuri',
    ks: 'Cachemiro (o cachemir)',
    ku: 'Kurdo',
    kv: 'Komi',
    kw: 'Córnico',
    ky: 'Kirguís',
    la: 'Latín',
    lb: 'Luxemburgués',
    lg: 'Luganda',
    li: 'Limburgués',
    ln: 'Lingala',
    lo: 'Lao',
    lt: 'Lituano',
    lu: 'Luba-katanga (o chiluba)',
    lv: 'Letón',
    mg: 'Malgache (o malagasy)',
    mh: 'Marshalés',
    mi: 'Maorí',
    mk: 'Macedonio',
    ml: 'Malayalam',
    mn: 'Mongol',
    mo: 'Moldavo',
    mr: 'Maratí',
    ms: 'Malayo',
    mt: 'Maltés',
    my: 'Birmano',
    na: 'Nauruano',
    nb: 'Noruego bokmål',
    nd: 'Ndebele del norte',
    ne: 'Nepalí',
    ng: 'Ndonga',
    nl: 'Neerlandés (u holandés)',
    nn: 'Nynorsk',
    no: 'Noruego',
    nr: 'Ndebele del sur',
    nv: 'Navajo',
    ny: 'Chichewa',
    oc: 'Occitano',
    oj: 'Ojibwa',
    om: 'Oromo',
    or: 'Oriya',
    os: 'Osético (u osetio, u oseta)',
    pa: 'Panyabí (o penyabi)',
    pi: 'Pali',
    pl: 'Polaco',
    ps: 'Pastú (o pastún, o pashto)',
    pt: 'Portugués',
    qu: 'Quechua',
    rm: 'Romanche',
    rn: 'Kirundi',
    ro: 'Rumano',
    ru: 'Ruso',
    rw: 'Ruandés (o kiñaruanda)',
    sa: 'Sánscrito',
    sc: 'Sardo',
    sd: 'Sindhi',
    se: 'Sami septentrional',
    sg: 'Sango',
    sh: 'Serbocroata',
    si: 'Cingalés',
    sk: 'Eslovaco',
    sl: 'Esloveno',
    sm: 'Samoano',
    sn: 'Shona',
    so: 'Somalí',
    sq: 'Albanés',
    sr: 'Serbio',
    ss: 'Suazi (o swati, o siSwati)',
    st: 'Sesotho',
    su: 'Sundanés (o sondanés)',
    sv: 'Sueco',
    sw: 'Suajili',
    ta: 'Tamil',
    te: 'Télugu',
    tg: 'Tayiko',
    th: 'Tailandés',
    ti: 'Tigriña',
    tk: 'Turcomano',
    tl: 'Tagalo',
    tn: 'Setsuana',
    to: 'Tongano',
    tr: 'Turco',
    ts: 'Tsonga',
    tt: 'Tártaro',
    tw: 'Twi',
    ty: 'Tahitiano',
    ug: 'Uigur',
    uk: 'Ucraniano',
    ur: 'Urdu',
    uz: 'Uzbeko',
    ve: 'Venda',
    vi: 'Vietnamita',
    vo: 'Volapük',
    wa: 'Valón',
    wo: 'Wolof',
    xh: 'Xhosa',
    yi: 'Yídish (o yidis, o yiddish)',
    yo: 'Yoruba',
    za: 'Chuan (o chuang, o zhuang)',
    zh: 'Chino',
    zu: 'Zulú',
    /**
     * Extended List
     */
    'en-GB': 'Inglés del Reino Unido',
    'es-MX': 'Español (México)',
    'pt-BR': 'Portugués Brasileño',
    'zh-TW': 'Chino tradicional',
};
